const component = {

	/**
	 * Init component
     * 
     * @return {undefined}
	 */
	init: () => {

        window.theme = window.theme || {};

        /**
         * Handleize a string
         * 
         * @global
         */
    	window.theme.handleize = component.handleize;
	},

    /**
	 * Handleize a string
     * 
     * @param {string} str Normal string.
     * @return {string} Handle.
	 */
    handleize: str => {

        // https://gist.github.com/tyteen4a03/3420a9e121d13b091343

        str = str.toLowerCase();

        let toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
        
        // For the old browsers
        for (let i = 0; i < toReplace.length; ++i) {
            str = str.replace(toReplace[i], "");
        }
    
        str = str.replace(/\W+/g, "-");
    
        if (str.charAt(str.length - 1) == "-") {
            str = str.replace(/-+\z/, "");
        }
    
        if (str.charAt(0) == "-") {
            str = str.replace(/\A-+/, "");
        }
    
        return str
    }
};

export default component;
